module.exports = __webpack_public_path__ + "static/media/3.400c7b2b.png";